import { rest } from 'msw';

import { getApiEndpoint } from '../../utils/baseUrls';
import { withScenario } from '../../utils/middleware';
import { mockResponse } from '../../utils/responseResult';
import apiResponses from './auth.json';

const checkPageAuthorization = (req, res, ctx) => {
  const search = typeof window !== 'undefined' ? window.location.search : '';
  const scenario = new URLSearchParams(search).get('scenario');
  if (scenario === 'redirectLogin') {
    return res(
      ctx.json(
        mockResponse(
          apiResponses['authorizationController/checkPageAuthorization'].error.redirectLogin,
          false,
          null
        )
      )
    );
  }
  if (scenario === 'userHaveAuthorityFalse') {
    return res(
      ctx.json(
        mockResponse(apiResponses['authorizationController/checkPageAuthorization'].success.userHaveAuthorityFalse)
      )
    );
  }
  return res(ctx.json(mockResponse(apiResponses['authorizationController/checkPageAuthorization'].success.default)));
};

const getLoginStatus = (req, res, ctx) => {
  // const mockType = req.headers.get('x-mock-response');
  // if (mockType === "error") return serverErrorResponse();

  return res(ctx.json(mockResponse(apiResponses['authorizationController/getLoginStatus'].success.default)));
};

export const handlers = [
  rest.post(getApiEndpoint('authorizationController/checkPageAuthorization'), withScenario(checkPageAuthorization)),
  rest.post(getApiEndpoint('authorizationController/getLoginStatus'), withScenario(getLoginStatus)),
];
